import  ActionType  from './ActionType';
import { IProgressItem } from '../components/mike-topbar-progress-spinner';

export interface DataAction {
  type:
    | ActionType.ADD_PROGRESS_ITEM
    | ActionType.RM_PROGRESS_ITEM
    | ActionType.UPDATE_PROGRESS_ITEM
    | ActionType.ADDUP_PROGRESS_ITEM;
  data: IProgressItem;
}

const addProgressItem = (state: IProgressItem[], action: DataAction) => {
  const _state = [action.data, ...state];
  // console.log('addProgressItem', _state);
  return _state;
};
const updateProgressItem = (state: IProgressItem[], action: DataAction, ix: number) => {
  state[ix] = action.data;
  // console.log('updateProgressItem', state, action, ix);
  return [...state];
};
// Check for matching item in state:
const getMatchIx = (state: IProgressItem[], item: IProgressItem) => {
  let ix = -1;
  state.forEach((entry, i) => {
    if (entry.id === item.id) ix = i;
  });
  return ix;
};

export const progressItemsReducer = (state: IProgressItem[], action: DataAction) => {
  switch (action.type) {
    case ActionType.ADD_PROGRESS_ITEM:
      // First check that 'id' field is unique:
      if (state.find(item => item.id === action.data.id)) {
        console.warn(
          `ADD_PROGRESS_ITEM: List of ProgressItems already has entry with id "${action.data.id}"`
        );
        return state;
      }
      // Go ahead if id is unique:
      return addProgressItem(state, action);

    case ActionType.RM_PROGRESS_ITEM:
      { 
        const rmState = state.filter(item => {
        return item.id !== action.data.id;
      });
      // console.log('ADD_PROGRESS_ITEM progressItems', _state);
      return [...rmState]; }
    // return rmProgressItem(state, action);

    case ActionType.UPDATE_PROGRESS_ITEM:
      // Find index, warn if no mach:
    { 
      const ix = getMatchIx(state, action.data);
      if (ix < 0) {
        console.warn(`UPDATE_PROGRESS_ITEM: No match for ${action.data.id}`);
        return state;
      }
      // Go ahead if match:
      return updateProgressItem(state, action, ix); }

    // Add or update if exists, a combination
    // of ADD_PROGRESS_ITEM and UPDATE_PROGRESS_ITEM:
    case ActionType.ADDUP_PROGRESS_ITEM:
      // Check if there's a match:
    {
      const jx = getMatchIx(state, action.data);
      if (jx > -1) {
        return updateProgressItem(state, action, jx);
      } else {
        return addProgressItem(state, action);
      } 
    }

    default:
      return state;
  }
};
